var exports = {
  "button": "Button.module__button___ZVR5cy",
  "matchSkeletonHeight": "Button.module__matchSkeletonHeight___ZVR5cy",
  "small": "Button.module__small___ZVR5cy",
  "compact": "Button.module__compact___ZVR5cy",
  "superCompact": "Button.module__superCompact___ZVR5cy",
  "fitContent": "Button.module__fitContent___ZVR5cy",
  "fitContainer": "Button.module__fitContainer___ZVR5cy",
  "square": "Button.module__square___ZVR5cy",
  "primary": "Button.module__primary___ZVR5cy",
  "secondary": "Button.module__secondary___ZVR5cy",
  "danger": "Button.module__danger___ZVR5cy",
  "inverted": "Button.module__inverted___ZVR5cy",
  "invertedOutline": "Button.module__invertedOutline___ZVR5cy",
  "ghost": "Button.module__ghost___ZVR5cy",
  "recording": "Button.module__recording___ZVR5cy",
  "buttonRecordingPulse": "Button.module__buttonRecordingPulse___ZVR5cy",
  "spinner": "Button.module__spinner___ZVR5cy",
  "spinnerInner": "Button.module__spinnerInner___ZVR5cy",
  "spinnerItem": "Button.module__spinnerItem___ZVR5cy",
  "spinnerPulsingEllipsis": "Button.module__spinnerPulsingEllipsis___ZVR5cy",
  "iconWrapper": "Button.module__iconWrapper___ZVR5cy",
  "spinnerWrapper": "Button.module__spinnerWrapper___ZVR5cy",
  "hidden": "Button.module__hidden___ZVR5cy",
  "grid": "Button.module__grid___ZVR5cy",
};

__webpack_require__.r(module.exports = exports);
